import { Toast, useToastState } from '@tamagui/toast';
import { useWindowDimensions } from 'react-native';
import { Text, XStack, YStack } from 'tamagui';

export const CustomToast = () => {
  const toast = useToastState();
  const { width } = useWindowDimensions();

  if (!toast || toast.isHandled) return null;

  return (
    <Toast
      key={toast.id}
      duration={toast.duration}
      enterStyle={{ opacity: 0, scale: 0.5, y: -25 }}
      exitStyle={{ opacity: 0, scale: 1, y: -20 }}
      y={0}
      opacity={1}
      scale={1}
      animation="100ms"
      backgroundColor="$primary"
      borderWidth={1}
      borderColor="$primary"
      shadowColor="#000"
      shadowOpacity={0.1}
      shadowRadius={10}
      shadowOffset={{ width: 0, height: 4 }}
      borderRadius="$4"
      padding="$3"
      minWidth={300}
      maxWidth="90%"
      position="absolute"
      alignSelf="center"
      top="15%"
      left={width / 2 - 160}
    >
      <XStack gap="$2" alignItems="center" justifyContent="center">
        <YStack flex={1} alignItems="center">
          {toast.title && (
            <Text color="white" fontWeight="600" fontSize="$5">
              {toast.title}
            </Text>
          )}
          {toast.message && (
            <Text color="white" fontSize="$3" marginTop={toast.title ? '$1' : 0}>
              {toast.message}
            </Text>
          )}
        </YStack>
      </XStack>
    </Toast>
  );
};
